// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {SeqId} from '../seq-id.js'

export class PDFPageMapping {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PDFPageMapping {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPDFPageMapping(bb: flatbuffers.ByteBuffer, obj?: PDFPageMapping): PDFPageMapping {
    return (obj || new PDFPageMapping()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPDFPageMapping(bb: flatbuffers.ByteBuffer, obj?: PDFPageMapping): PDFPageMapping {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PDFPageMapping()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  pdfPageNumber(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0
  }

  pageId(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startPDFPageMapping(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addPdfPageNumber(builder: flatbuffers.Builder, pdfPageNumber: number) {
    builder.addFieldInt32(0, pdfPageNumber, 0)
  }

  static addPageId(builder: flatbuffers.Builder, pageIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, pageIdOffset, 0)
  }

  static endPDFPageMapping(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // page_id
    return offset
  }
}
